// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"5a2ec6e3","165":"b2c4b468","315":"5a389889","641":"5e2acb74","787":"07ec3f6c","815":"89b59299","849":"1309491f"}[chunkId] + ".chunk.js";
};